// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FileImagePreview_wrapper___fugu","inner":"FileImagePreview_inner__JUJyW","imageContainer":"FileImagePreview_imageContainer___XAbo","fit":"FileImagePreview_fit__yZXcD"};